import { useFeature } from '@growthbook/growthbook-react';
import { GridInitialStatePremium } from '@mui/x-data-grid-premium/models/gridStatePremium';
import * as Sentry from '@sentry/react';
import { useCallback } from 'react';
import { FeatureFlags } from 'types';
import { DatagridNames } from 'types/datagrid';

export enum DATAGRID_BREADCRUMB_TYPES {
  USER_SAVED = 'user_saved',
  INITIAL_LOADED = 'initial_loaded',
}

export const DATAGRID_BREADCRUMB_TYPES_MAP = {
  [DATAGRID_BREADCRUMB_TYPES.USER_SAVED]: 'New datagrid state saved by user',
  [DATAGRID_BREADCRUMB_TYPES.INITIAL_LOADED]: 'Initial datagrid state loaded',
};

export default function useAddDatagridBreadcrumb() {
  const tempSentryReplay = useFeature(FeatureFlags.tempSentryReplay).on;

  const handleLogSavedState = useCallback(
    ({
      gridState,
      gridName,
      type,
    }: {
      gridState: GridInitialStatePremium;
      gridName: DatagridNames;
      type: DATAGRID_BREADCRUMB_TYPES;
    }) => {
      if (tempSentryReplay)
        Sentry.addBreadcrumb({
          type: 'custom',
          data: {
            type: DATAGRID_BREADCRUMB_TYPES_MAP[type],
            gridName,
            savedState: gridState,
            orderedVisibleColumns: gridState.columns?.orderedFields?.filter(
              (fieldName) =>
                // Columns not in the columnVisibilityModel are visible by default.
                // So, only columns explicitly set to false are not visible
                (gridState.columns?.columnVisibilityModel ?? {})[fieldName] !==
                false
            ),
          },
          level: 'info',
          category: 'Datagrid State',
        });
    },
    [tempSentryReplay]
  );

  return { handleLogSavedState };
}
